import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { JsonViewer } from "@plansoft-configuration-renderer/debug";
export function PromiseView(props) {
    const [data, setData] = useState({});
    useEffect(() => {
        let skip = false;
        function unwrap() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (!skip) {
                        const obj = yield props.data;
                        setData(obj);
                    }
                }
                catch (err) {
                    console.log(err);
                }
            });
        }
        unwrap();
        return () => {
            skip = true;
        };
    }, [props.data]);
    if (typeof data === "string") {
        return _jsx("pre", { children: data });
    }
    return _jsx(JsonViewer, { src: data, name: "PromiseView", expandDepth: 1 });
}
//# sourceMappingURL=PromiseView.js.map